<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <d-card-header
            class="d-flex justify-content-between align-items-center"
          >
            <h2 class="h4">{{ this.$store.state.team.count }} Team Members</h2>
            <d-link to="Team/add">
              <d-button theme="primary" light size="sm">Add</d-button>
            </d-link>
          </d-card-header>
          <d-card-body class="p-0 pb-3 text-center overflow-auto">
            <loading v-show="loading" />
            <table v-show="!loading" class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0 text-left">First Name</th>
                  <th scope="col" class="border-0 text-left">Last Name</th>
                  <th scope="col" class="border-0">Phone</th>
                  <th scope="col" class="border-0">Code</th>
                  <th scope="col" class="border-0">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="member in members" :key="member.key">
                  <td class="text-left">{{ member.first_name }}</td>
                  <td class="text-left">{{ member.last_name }}</td>
                  <td>{{ member.phone || "..." }}</td>
                  <td>****</td>
                  <td class>
                    <d-button
                      theme="primary"
                      light
                      round
                      size="sm"
                      class="mx-1"
                      @click="editTeamMember(member.key)"
                    >
                      <i class="material-icons">edit</i>
                    </d-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </d-card-body>
          <d-card-footer
            class="d-flex justify-content-center align-items-center"
          >
            <Paginator
              :nextClick="getNextMembers"
              :prevClick="getPrevMembers"
              :numPages="this.$store.state.team.numPages"
              :pageNum="this.$store.state.team.pageNum"
            />
          </d-card-footer>
        </d-card>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import Paginator from "@/components/common/Paginator.vue";

export default {
  created() {
    this.$store.dispatch("team/initMembers");
    this.$store.dispatch("app/setTitles", {title: 'Team', subtitle: ''});
  },
  components: {
    Paginator
  },
  computed: {
    members() {
      return this.$store.state.team.members;
    },
    loading() {
      return this.$store.state.team.loading;
    }
  },
  methods: {
    editTeamMember(key) {
      this.$router.push({ name: "team_edit_key", params: { key } });
    },
    getNextMembers() {
      this.$store.dispatch("team/nextMembers");
    },
    getPrevMembers() {
      this.$store.dispatch("team/prevMembers");
    }
  }
};
</script>

<style scoped>
.action-btn {
  font-size: 1rem;
}
</style>
